import { createApiCall } from 'lib/base';

const REINIT_STOCK_ACCOUNT_ESIGN_EKYC_API_ID =
  'DASHBOARD/REINIT_STOCK_ACCOUNT_ESIGN_EKYC_API';

const apiCall = createApiCall(
  REINIT_STOCK_ACCOUNT_ESIGN_EKYC_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/stock-accounts/${id}/esign-ekyc/reinit`,
    method: 'POST',
    notify: true,
    isReload: true,
  })
);

export default apiCall;
